var _rect, _path, _path2, _path3, _path4, _path5, _path6, _mask, _rect2, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVerification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 220,
    viewBox: "0 0 219 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.496094,
    width: 218.182,
    height: 220,
    rx: 15,
    fill: "#5D38E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5249 45.1501H144.488V75.1644V118.95L144.488 170.55H60.0749V66.6001C60.0749 54.7536 69.6784 45.1501 81.5249 45.1501Z",
    stroke: "white",
    strokeWidth: 6.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3975 63.6683C57.3975 51.6184 67.1658 41.8501 79.2156 41.8501V41.8501V58.5072C79.2156 61.8052 76.5421 64.4787 73.2442 64.4787H57.3975V63.6683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8613 76.5869H130.842",
    stroke: "white",
    strokeWidth: 4.95,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8613 87.0945H130.842",
    stroke: "white",
    strokeWidth: 4.95,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2097 116.1H89.2886C89.6189 116.1 89.8866 116.368 89.8866 116.698V160.091C89.8866 160.421 89.6189 160.689 89.2886 160.689H78.2097C77.8795 160.689 77.6117 160.421 77.6117 160.091V116.698C77.6117 116.368 77.8795 116.1 78.2097 116.1Z",
    stroke: "white",
    strokeWidth: 4.95
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9612 104.55H110.04C110.37 104.55 110.638 104.818 110.638 105.148V160.091C110.638 160.421 110.37 160.689 110.04 160.689H98.9612C98.6309 160.689 98.3632 160.421 98.3632 160.091V105.148C98.3632 104.818 98.6309 104.55 98.9612 104.55Z",
    stroke: "white",
    strokeWidth: 4.95
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_93_1932",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.017,
    y: 137.393,
    width: 17.2249,
    height: 25.7714,
    rx: 3.07302
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.017,
    y: 137.393,
    width: 17.2249,
    height: 25.7714,
    rx: 3.07302,
    stroke: "white",
    strokeWidth: 9.9,
    mask: "url(#path-8-inside-1_93_1932)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.246 150.75C171.246 167.179 158.045 180.45 141.819 180.45C125.592 180.45 112.391 167.179 112.391 150.75C112.391 134.321 125.592 121.05 141.819 121.05C158.045 121.05 171.246 134.321 171.246 150.75Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 6.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.498 146.601L143.774 159.43C143.133 160.077 142.092 160.077 141.451 159.43L128.728 146.601",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerification);
export default __webpack_public_path__ + "static/media/icon_verification.021e883e12a6e1e7319ef1fca774b4ed.svg";
export { ForwardRef as ReactComponent };